import { FETCH_ALL_TASKS_LIST_STATUS_FAILED, FETCH_ALL_TASKS_LIST_STATUS_PENDING, FETCH_ALL_TASKS_LIST_STATUS_SUCCESS, FETCH_ALL_TASKS_PRIORITY, FETCH_ALL_TASKS_STATUS, FETCH_ALL_TYPE_STATUS, FETCH_PACKING_LABELS, FETCH_PACKING_LABELS_STATUS, FETCH_SHIPPED_LABEL_HISTORY, FETCH_SHIPPED_LABEL_HISTORY_STATUS } from "../types";

const initialState = {
    packingLabelList: [],
    packingLabelListStatus: '',
    shippedLabelHistory: [],
    shippedLabelHistoryStatus: '',
    allTaskPriorityList: [],
    allTaskStatusList: [],
    allTaskTypeList: [],
    allTaskListStatus: '',
    allTaskList: '',
}
const PickerReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_PACKING_LABELS_STATUS:
            return {
                ...state,
                packingLabelListStatus: 'PENDING',
                packingLabelList: [],
            };
        case FETCH_PACKING_LABELS:
            return {
                ...state,
                packingLabelListStatus: 'SUCCESS',
                packingLabelList: payload,
            };
        case FETCH_SHIPPED_LABEL_HISTORY_STATUS:
            return {
                ...state,
                shippedLabelHistoryStatus: 'PENDING',
                shippedLabelHistory: [],
            };
        case FETCH_SHIPPED_LABEL_HISTORY:
            return {
                ...state,
                shippedLabelHistoryStatus: 'SUCCESS',
                shippedLabelHistory: payload,
            };
        case FETCH_ALL_TASKS_PRIORITY:
            return {
                ...state,
                allTaskPriorityList: payload,
            };
        case FETCH_ALL_TASKS_STATUS:
            return {
                ...state,
                allTaskStatusList: payload,
            };
        case FETCH_ALL_TYPE_STATUS:
            return {
                ...state,
                allTaskTypeList: payload,
            };
        case FETCH_ALL_TASKS_LIST_STATUS_PENDING:
            return {
                ...state,
                allTaskListStatus: 'PENDING',
                allTaskList: [],
            };
        case FETCH_ALL_TASKS_LIST_STATUS_SUCCESS:
            return {
                ...state,
                allTaskListStatus: 'SUCCESS',
                allTaskList: payload,
            };
        case FETCH_ALL_TASKS_LIST_STATUS_FAILED:
            return {
                ...state,
                allTaskListStatus: 'FAILED',
                allTaskList: [],
            };
        default:
            return state;
    }
}
export default PickerReducer;